import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dash" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "rol-chip" }
const _hoisted_4 = { class: "subtitulo" }
const _hoisted_5 = { class: "kpis" }
const _hoisted_6 = {
  key: 1,
  class: "aviso-error"
}
const _hoisted_7 = { class: "kpis" }
const _hoisted_8 = { class: "kpi-num" }
const _hoisted_9 = { class: "kpi-lbl" }
const _hoisted_10 = { class: "kpi-sub" }
const _hoisted_11 = { class: "kpi-sub" }
const _hoisted_12 = { class: "kpi-lbl" }
const _hoisted_13 = { class: "kpi-sub" }
const _hoisted_14 = { class: "kpi-num azul" }
const _hoisted_15 = { class: "kpi-sub" }
const _hoisted_16 = { class: "kpi-barra" }
const _hoisted_17 = { class: "kpi-lbl" }
const _hoisted_18 = { class: "kpi-sub" }
const _hoisted_19 = {
  key: 0,
  class: "tarjeta hoy-toca"
}
const _hoisted_20 = {
  key: 0,
  class: "vacio"
}
const _hoisted_21 = {
  key: 1,
  class: "toca-grid"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "toca-factor" }
const _hoisted_24 = { class: "toca-meta" }
const _hoisted_25 = { class: "toca-datos" }
const _hoisted_26 = {
  key: 0,
  class: "txt-ambar"
}
const _hoisted_27 = {
  key: 2,
  class: "toca-plan"
}
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = { class: "tarjeta-cab" }
const _hoisted_30 = { class: "resumen-sev" }
const _hoisted_31 = {
  key: 0,
  class: "pill p-rojo"
}
const _hoisted_32 = {
  key: 1,
  class: "pill p-ambar"
}
const _hoisted_33 = {
  key: 2,
  class: "pill p-azul"
}
const _hoisted_34 = {
  key: 0,
  class: "vacio ok"
}
const _hoisted_35 = {
  key: 1,
  class: "alertas"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "alerta-titulo" }
const _hoisted_38 = {
  key: 0,
  class: "alerta-detalle"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 2,
  class: "ver-mas"
}
const _hoisted_41 = { class: "tarjeta col-5" }
const _hoisted_42 = { class: "tarjeta-cab" }
const _hoisted_43 = {
  key: 0,
  class: "vacio"
}
const _hoisted_44 = {
  key: 1,
  class: "eventos"
}
const _hoisted_45 = { class: "ev-cuerpo" }
const _hoisted_46 = { class: "ev-titulo" }
const _hoisted_47 = { class: "ev-meta" }
const _hoisted_48 = {
  key: 1,
  class: "tarjeta"
}
const _hoisted_49 = { class: "tarjeta-cab" }
const _hoisted_50 = { class: "cuenta" }
const _hoisted_51 = {
  key: 0,
  class: "vacio"
}
const _hoisted_52 = {
  key: 1,
  class: "contenedor-tabla"
}
const _hoisted_53 = { class: "lista-tabla" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "prog-nombre" }
const _hoisted_56 = { class: "ctr" }
const _hoisted_57 = { class: "mini-barra" }
const _hoisted_58 = {
  key: 1,
  class: "sin-dato"
}
const _hoisted_59 = { class: "ctr" }
const _hoisted_60 = {
  key: 0,
  class: "pill p-rojo"
}
const _hoisted_61 = {
  key: 1,
  class: "sin-dato"
}
const _hoisted_62 = {
  key: 2,
  class: "semaforo-paginacion"
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "pag-info" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = {
  key: 2,
  class: "grid"
}
const _hoisted_67 = { class: "tarjeta col-5" }
const _hoisted_68 = {
  key: 0,
  class: "vacio"
}
const _hoisted_69 = { class: "plan-kpis" }
const _hoisted_70 = { class: "plan-kpi" }
const _hoisted_71 = { class: "pk-num azul" }
const _hoisted_72 = { class: "plan-kpi" }
const _hoisted_73 = { class: "plan-kpi" }
const _hoisted_74 = { class: "pk-num" }
const _hoisted_75 = { class: "plan-estados" }
const _hoisted_76 = { class: "tarjeta col-7" }
const _hoisted_77 = { class: "tarjeta-cab" }
const _hoisted_78 = { class: "selector" }
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  key: 1,
  class: "vacio"
}
const _hoisted_81 = {
  key: 3,
  class: "tarjeta"
}
const _hoisted_82 = { class: "tarjeta-cab" }
const _hoisted_83 = { class: "selector" }
const _hoisted_84 = ["value"]
const _hoisted_85 = {
  key: 1,
  class: "vacio"
}
const _hoisted_86 = {
  key: 4,
  class: "tarjeta"
}
const _hoisted_87 = { class: "pie" }

import { ref, computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import useAutenticar from '@/store/IngresoAutenticar'
import { useDashboardFiltros } from '@/store/DashboardFiltros'
import { getDashboardService, atenderAlertaService, type DashboardPayload, type AlertaDashboard } from '@/services/DashboardService'
import AvanceFactorPanel from '@/components/AvanceFactorPanel.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'

const SEMAFORO_POR_PAGINA = 10

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

/**
 * RF-13 · Tablero principal con alertas y calendario.
 *
 * Las alertas las produce un motor de 13 reglas del backend, y cada una trae la
 * ruta del módulo que la resuelve: se atienden en un clic.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const router = useRouter()
const auth = useAutenticar()
const filtros = useDashboardFiltros()

const d = ref<DashboardPayload | null>(null)

const mensajeVisible = ref(false)
const mensajeTexto   = ref('')
const mensajeTipo    = ref<'positivo' | 'error'>('error')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'error') {
  mensajeTexto.value   = texto
  mensajeTipo.value    = tipo
  mensajeVisible.value = true
}
const cargando = ref(false)
const error = ref('')
const refAlertas = ref<HTMLElement | null>(null)

const paginaSemaforo = ref(0)

const semaforoFiltrado = computed(() =>
  (d.value?.semaforo_programas ?? []).filter(p => p.estado !== 'finalizado')
)
const semaforoPagina = computed(() => {
  const inicio = paginaSemaforo.value * SEMAFORO_POR_PAGINA
  return semaforoFiltrado.value.slice(inicio, inicio + SEMAFORO_POR_PAGINA)
})
const totalPaginasSemaforo = computed(() =>
  Math.ceil(semaforoFiltrado.value.length / SEMAFORO_POR_PAGINA)
)

const nombre = computed(() => d.value?.usuario.name ?? auth.usuarioActual?.name ?? 'Usuario')
const rol = computed(() => d.value?.usuario.rol ?? auth.usuarioActual?.role?.label ?? 'Usuario')
const saludo = computed(() => {
  const h = new Date().getHours()
  return h < 12 ? 'Buenos días' : h < 19 ? 'Buenas tardes' : 'Buenas noches'
})
const hoyLargo = new Date().toLocaleDateString('es-CO', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })

const puedeGestionarCal = computed(() => auth.tienePermiso('calendario.gestionar'))
const puedeAtender = computed(() => auth.tienePermiso('alertas.atender'))

const ejecucionSeleccionada = computed<number | null>({
  get: () => filtros.idEjecucion ?? d.value?.id_ejecucion_foco ?? null,
  set: (v) => { filtros.idEjecucion = v }
})

const kpiUrgencia = computed(() => {
  const dias = d.value?.kpis.proximo_evento?.dias_restantes
  if (dias === undefined || dias === null) return ''
  return dias <= 7 ? 'kpi-critico' : dias <= 30 ? 'kpi-alto' : ''
})

const horaGenerado = computed(() => {
  if (!d.value) return ''
  const t = new Date(d.value.generado_en)
  return isNaN(t.getTime()) ? '' : t.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' })
})

function fmtFecha(iso: string): string {
  const x = new Date(iso + 'T00:00:00')
  return isNaN(x.getTime()) ? iso : x.toLocaleDateString('es-CO', { day: '2-digit', month: 'short' })
}
function urgencia(dias: number): string {
  return dias <= 7 ? 'u-critica' : dias <= 30 ? 'u-alta' : dias <= 90 ? 'u-media' : 'u-info'
}
function urgenciaTxt(dias: number): string {
  return dias <= 7 ? 'txt-rojo' : dias <= 30 ? 'txt-ambar' : 'txt-azul'
}

const ETAPAS: Record<string, { t: string; c: string }> = {
  preparacion: { t: 'Preparación', c: 'p-gris' },
  ejecucion: { t: 'Ejecución', c: 'p-ambar' },
  evaluacion: { t: 'Evaluación', c: 'p-azul' },
  informe: { t: 'Informe', c: 'p-teal' },
  finalizado: { t: 'Finalizado', c: 'p-verde' }
}
const etapaTexto = (e: string) => ETAPAS[e]?.t ?? e
const etapaClase = (e: string) => ETAPAS[e]?.c ?? 'p-gris'

function estadoPlanClase(e: string): string {
  return { NO_INICIADO: 'p-naranja', EN_DESARROLLO: 'p-ambar', CUMPLIDO: 'p-verde', NO_CUMPLIDO: 'p-rojo', ANULADO: 'p-azul' }[e] ?? 'p-gris'
}

function ir(ruta: string): void { router.push(ruta) }

function scrollAlertas(): void {
  refAlertas.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

async function atender(a: AlertaDashboard): Promise<void> {
  const r = await atenderAlertaService(a)
  if (r.ok && d.value) {
    d.value.alertas.items = d.value.alertas.items.filter(x => x !== a)
    d.value.alertas.total = Math.max(0, d.value.alertas.total - 1)
    if (['critica', 'alta'].includes(a.severidad)) {
      d.value.kpis.alertas_criticas = Math.max(0, d.value.kpis.alertas_criticas - 1)
    }
  }
}

async function cargar(): Promise<void> {
  cargando.value = true
  error.value = ''
  const r = await getDashboardService(filtros.idEjecucion)
  if (r.ok && r.data) {
    d.value = r.data
    if (!filtros.idEjecucion && r.data.id_ejecucion_foco) filtros.idEjecucion = r.data.id_ejecucion_foco
  } else {
    error.value = r.error ?? 'No se pudo cargar el dashboard'
  }
  cargando.value = false
}

onMounted(cargar)
watch(() => filtros.idEjecucion, (nuevo, viejo) => { if (nuevo !== viejo && viejo !== null) cargar() })
watch(error, (val) => { if (val) mostrarMensaje(val, 'error') })

return (_ctx: any,_cache: any) => {
  const _directive_drag_scroll = _resolveDirective("drag-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, [
          _createTextVNode(_toDisplayString(saludo.value) + ", " + _toDisplayString(nombre.value) + " ", 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(rol.value), 1)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(hoyLargo)), 1)
      ])
    ]),
    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (cargando.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "skeleton sk-kpi"
              })
            }), 64))
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "grid" }, [
            _createElementVNode("div", { class: "skeleton sk-tarjeta col-7" }),
            _createElementVNode("div", { class: "skeleton sk-tarjeta col-5" })
          ], -1))
        ], 64))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn chico",
              onClick: cargar
            }, "Reintentar")
          ]))
        : (d.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("section", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["kpi", kpiUrgencia.value]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (ir('/calendario')))
                }, [
                  (d.value.kpis.proximo_evento)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_8, [
                          _createTextVNode(_toDisplayString(d.value.kpis.proximo_evento.dias_restantes), 1),
                          _cache[13] || (_cache[13] = _createElementVNode("small", null, " días", -1))
                        ]),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(d.value.kpis.proximo_evento.titulo), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(d.value.kpis.proximo_evento.tipo_label) + " · " + _toDisplayString(fmtFecha(d.value.kpis.proximo_evento.fecha)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "kpi-num" }, "—", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "kpi-lbl" }, "Sin fechas registradas", -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(puedeGestionarCal.value ? 'Registra la primera en el calendario' : 'La Dirección de Calidad las registra'), 1)
                      ], 64))
                ], 2),
                _createElementVNode("button", {
                  class: "kpi",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (d.value.id_ejecucion_foco && ir(`/ejecucion/${d.value.id_ejecucion_foco}/resultados`)))
                }, [
                  (d.value.kpis.calificacion)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["kpi-num", 'txt-' + d.value.kpis.calificacion.clasificacion])
                        }, _toDisplayString(d.value.kpis.calificacion.valoracion.toFixed(2)), 3),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(d.value.kpis.calificacion.grado ?? 'Calificación global'), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(d.value.kpis.calificacion.programa) + " · " + _toDisplayString(d.value.kpis.calificacion.periodo), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "kpi-num" }, "—", -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "kpi-lbl" }, "Sin calificación aún", -1)),
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "kpi-sub" }, "El roll-up aparece al consolidar indicadores", -1))
                      ], 64))
                ]),
                _createElementVNode("button", {
                  class: "kpi",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (d.value.id_ejecucion_foco && ir(`/ejecucion/${d.value.id_ejecucion_foco}/avance`)))
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(d.value.kpis.avance.pct === null ? '—' : d.value.kpis.avance.pct.toFixed(0) + '%'), 1),
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "kpi-lbl" }, "Avance de evaluación", -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(d.value.kpis.avance.calificados) + " de " + _toDisplayString(d.value.kpis.avance.total) + " indicadores calificados", 1),
                  _createElementVNode("span", _hoisted_16, [
                    _createElementVNode("span", {
                      class: "kpi-barra-rel",
                      style: _normalizeStyle({ width: (d.value.kpis.avance.pct ?? 0) + '%' })
                    }, null, 4)
                  ])
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["kpi", { 'kpi-alerta': d.value.kpis.alertas_criticas > 0 }]),
                  onClick: scrollAlertas
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["kpi-num", d.value.kpis.alertas_criticas > 0 ? 'txt-rojo' : 'txt-verde'])
                  }, _toDisplayString(d.value.kpis.alertas_criticas), 3),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(d.value.kpis.alertas_criticas === 1 ? 'Alerta que requiere acción' : 'Alertas que requieren acción'), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(d.value.alertas.total) + " en total · críticas y altas primero", 1)
                ], 2)
              ]),
              (d.value.vista === 'lider' && d.value.mis_pendientes)
                ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "tarjeta-cab" }, [
                      _createElementVNode("h2", null, "Hoy te toca")
                    ], -1)),
                    (!d.value.mis_pendientes?.factores.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, "No tienes factores asignados en procesos activos. ✓"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.value.mis_pendientes?.factores, (f) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: f.id_ejecucion + f.factor,
                              class: "toca-item",
                              onClick: ($event: any) => (ir(`/ejecucion/${f.id_ejecucion}/avance`))
                            }, [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(f.factor), 1),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(f.programa) + " · " + _toDisplayString(f.periodo), 1),
                              _createElementVNode("span", _hoisted_25, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'txt-rojo': f.indicadores_pendientes > 0 })
                                }, _toDisplayString(f.indicadores_pendientes) + " indicadores por calificar", 3),
                                (f.bloques_sin_redactar > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "· " + _toDisplayString(f.bloques_sin_redactar) + " bloques sin redactar", 1))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, _hoisted_22))
                          }), 128))
                        ])),
                    (d.value.mis_pendientes?.acciones_por_vencer > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, " ⚠ " + _toDisplayString(d.value.mis_pendientes?.acciones_por_vencer) + " acción(es) del plan de tus características vencen en ≤30 días. ", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("section", {
                  ref_key: "refAlertas",
                  ref: refAlertas,
                  class: "tarjeta col-7"
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[21] || (_cache[21] = _createElementVNode("h2", null, "Centro de alertas", -1)),
                    _createElementVNode("span", _hoisted_30, [
                      (d.value.alertas.por_severidad.critica)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(d.value.alertas.por_severidad.critica) + " críticas", 1))
                        : _createCommentVNode("", true),
                      (d.value.alertas.por_severidad.alta)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(d.value.alertas.por_severidad.alta) + " altas", 1))
                        : _createCommentVNode("", true),
                      (d.value.alertas.por_severidad.media)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(d.value.alertas.por_severidad.media) + " medias", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (!d.value.alertas.items.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[22] || (_cache[22] = [
                        _createElementVNode("span", { class: "ok-ico" }, "✓", -1),
                        _createTextVNode(" Sin alertas pendientes — todo bajo control. ")
                      ])))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.value.alertas.items, (a, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: a.clave + '-' + i,
                            class: _normalizeClass(["alerta", 'b-' + a.severidad])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["sev-ico", 's-' + a.severidad])
                            }, _toDisplayString(a.severidad === 'critica' ? '⚠' : a.severidad === 'alta' ? '!' : 'i'), 3),
                            _createElementVNode("div", {
                              class: _normalizeClass(["alerta-cuerpo", { enlazable: !!a.enlace_frontend }]),
                              onClick: ($event: any) => (a.enlace_frontend && ir(a.enlace_frontend))
                            }, [
                              _createElementVNode("span", _hoisted_37, _toDisplayString(a.titulo), 1),
                              (a.detalle)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(a.detalle), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_36),
                            (puedeAtender.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn-atender",
                                  title: "Marcar como atendida",
                                  onClick: ($event: any) => (atender(a))
                                }, "✓", 8, _hoisted_39))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ])),
                  (d.value.alertas.items.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                        _createTextVNode(_toDisplayString(d.value.alertas.items.length) + " alerta(s) · las más severas primero", 1),
                        (d.value.alertas.total > d.value.alertas.items.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(", mostrando " + _toDisplayString(d.value.alertas.items.length) + " de " + _toDisplayString(d.value.alertas.total), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        _cache[23] || (_cache[23] = _createTextVNode(". "))
                      ]))
                    : _createCommentVNode("", true)
                ], 512),
                _createElementVNode("section", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[24] || (_cache[24] = _createElementVNode("h2", null, "Próximos eventos", -1)),
                    _createElementVNode("button", {
                      class: "btn chico",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (ir('/calendario')))
                    }, "Calendario →")
                  ]),
                  (!d.value.proximos_eventos.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _cache[26] || (_cache[26] = _createTextVNode(" Aún no hay eventos próximos")),
                        (puedeGestionarCal.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[25] || (_cache[25] = _createTextVNode(" — ")),
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (ir('/calendario')), ["prevent"]))
                              }, "registrar el primero")
                            ], 64))
                          : _createCommentVNode("", true),
                        _cache[27] || (_cache[27] = _createTextVNode(". "))
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.value.proximos_eventos, (e) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: e.id_evento,
                            class: "evento",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (ir('/calendario')))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["ev-dias", urgencia(e.dias_restantes)])
                            }, [
                              _createTextVNode(_toDisplayString(e.dias_restantes), 1),
                              _cache[28] || (_cache[28] = _createElementVNode("small", null, "d", -1))
                            ], 2),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(e.titulo), 1),
                              _createElementVNode("span", _hoisted_47, [
                                _createTextVNode(_toDisplayString(e.tipo_label), 1),
                                (e.programa)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · " + _toDisplayString(e.programa), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" · " + _toDisplayString(fmtFecha(e.fecha_inicio)), 1)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                ])
              ]),
              (d.value.vista === 'gestion' || _unref(auth).esAdmin)
                ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[29] || (_cache[29] = _createElementVNode("h2", null, "Semáforo de programas", -1)),
                      _createElementVNode("span", _hoisted_50, _toDisplayString(semaforoFiltrado.value.length) + " proceso(s) activo(s) · ordenados por riesgo", 1)
                    ]),
                    (!semaforoFiltrado.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, "No hay procesos activos."))
                      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("table", _hoisted_53, [
                            _cache[31] || (_cache[31] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Programa"),
                                _createElementVNode("th", null, "Periodo"),
                                _createElementVNode("th", null, "Etapa"),
                                _createElementVNode("th", { class: "ctr" }, "Avance"),
                                _createElementVNode("th", null, "Hito más próximo"),
                                _createElementVNode("th", { class: "ctr" }, "Alertas"),
                                _createElementVNode("th")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(semaforoPagina.value, (p) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: p.id_ejecucion,
                                  class: "fila-prog",
                                  onClick: ($event: any) => (ir(`/ejecucion/${p.id_ejecucion}/avance`))
                                }, [
                                  _createElementVNode("td", _hoisted_55, _toDisplayString(p.programa), 1),
                                  _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["pill", etapaClase(p.estado)])
                                    }, _toDisplayString(etapaTexto(p.estado)), 3)
                                  ]),
                                  _createElementVNode("td", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("span", {
                                        style: _normalizeStyle({ width: (p.pct_calificados ?? 0) + '%' })
                                      }, null, 4)
                                    ]),
                                    _createElementVNode("small", null, _toDisplayString(p.pct_calificados === null ? 'N/D' : p.pct_calificados.toFixed(0) + '%'), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    (p.hito)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("b", {
                                            class: _normalizeClass(urgenciaTxt(p.hito.dias_restantes))
                                          }, _toDisplayString(p.hito.dias_restantes) + " días", 3),
                                          _createTextVNode(" · " + _toDisplayString(p.hito.titulo), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_58, "Sin hito registrado"))
                                  ]),
                                  _createElementVNode("td", _hoisted_59, [
                                    (p.alertas)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(p.alertas), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_61, "0"))
                                  ]),
                                  _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ctr flecha" }, "→", -1))
                                ], 8, _hoisted_54))
                              }), 128))
                            ])
                          ])
                        ])), [
                          [_directive_drag_scroll]
                        ]),
                    (totalPaginasSemaforo.value > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: paginaSemaforo.value === 0,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (paginaSemaforo.value--))
                          }, "Atrás", 8, _hoisted_63),
                          _createElementVNode("span", _hoisted_64, "Página " + _toDisplayString(paginaSemaforo.value + 1) + " de " + _toDisplayString(totalPaginasSemaforo.value), 1),
                          _createElementVNode("button", {
                            class: "pag-btn",
                            disabled: paginaSemaforo.value >= totalPaginasSemaforo.value - 1,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (paginaSemaforo.value++))
                          }, "Siguiente", 8, _hoisted_65)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (d.value.vista === 'gestion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("section", _hoisted_67, [
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "tarjeta-cab" }, [
                        _createElementVNode("h2", null, "Plan de mejoramiento")
                      ], -1)),
                      (!d.value.plan_salud.total)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, "Aún no hay acciones de plan registradas."))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("span", _hoisted_71, _toDisplayString(d.value.plan_salud.pct_avance?.toFixed(0) ?? '—') + "%", 1),
                                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "pk-lbl" }, "Avance promedio", -1))
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pk-num", d.value.plan_salud.vencidas ? 'txt-rojo' : 'txt-verde'])
                                }, _toDisplayString(d.value.plan_salud.vencidas), 3),
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "pk-lbl" }, "Vencidas", -1))
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("span", _hoisted_74, _toDisplayString(d.value.plan_salud.total), 1),
                                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "pk-lbl" }, "Acciones", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.value.plan_salud.por_estado, (n, est) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: est,
                                  class: _normalizeClass(["pill", estadoPlanClase(String(est))])
                                }, _toDisplayString(String(est).replace('_', ' ')) + ": " + _toDisplayString(n), 3))
                              }), 128))
                            ]),
                            (d.value.id_ejecucion_foco)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn chico enlace-plan",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (ir(`/ejecucion/${d.value.id_ejecucion_foco}/plan-mejoramiento`)))
                                }, "Ir al plan →"))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _createElementVNode("section", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _cache[37] || (_cache[37] = _createElementVNode("h2", null, "Avance por factor", -1)),
                        _createElementVNode("label", _hoisted_78, [
                          _cache[36] || (_cache[36] = _createTextVNode("Proceso: ")),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ejecucionSeleccionada).value = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(semaforoFiltrado.value, (p) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: p.id_ejecucion,
                                value: p.id_ejecucion
                              }, _toDisplayString(p.programa) + " · " + _toDisplayString(p.periodo), 9, _hoisted_79))
                            }), 128))
                          ], 512), [
                            [
                              _vModelSelect,
                              ejecucionSeleccionada.value,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ]),
                      (ejecucionSeleccionada.value)
                        ? (_openBlock(), _createBlock(AvanceFactorPanel, {
                            "id-ejecucion": ejecucionSeleccionada.value,
                            key: ejecucionSeleccionada.value
                          }, null, 8, ["id-ejecucion"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_80, "Selecciona un proceso."))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (d.value.vista !== 'gestion' && _unref(auth).esAdmin)
                ? (_openBlock(), _createElementBlock("section", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _cache[39] || (_cache[39] = _createElementVNode("h2", null, "Avance por factor", -1)),
                      _createElementVNode("label", _hoisted_83, [
                        _cache[38] || (_cache[38] = _createTextVNode("Proceso: ")),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ejecucionSeleccionada).value = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(semaforoFiltrado.value, (p) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: p.id_ejecucion,
                              value: p.id_ejecucion
                            }, _toDisplayString(p.programa) + " · " + _toDisplayString(p.periodo), 9, _hoisted_84))
                          }), 128))
                        ], 512), [
                          [
                            _vModelSelect,
                            ejecucionSeleccionada.value,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]),
                    (ejecucionSeleccionada.value)
                      ? (_openBlock(), _createBlock(AvanceFactorPanel, {
                          "id-ejecucion": ejecucionSeleccionada.value,
                          key: ejecucionSeleccionada.value
                        }, null, 8, ["id-ejecucion"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_85, "Selecciona un proceso para ver el avance."))
                  ]))
                : _createCommentVNode("", true),
              (d.value.vista === 'lider' && d.value.mis_pendientes?.factores.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_86, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "tarjeta-cab" }, [
                      _createElementVNode("h2", null, "Avance de tus procesos")
                    ], -1)),
                    _createVNode(AvanceFactorPanel, {
                      "id-ejecucion": d.value.mis_pendientes!.factores[0].id_ejecucion
                    }, null, 8, ["id-ejecucion"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_87, "Actualizado " + _toDisplayString(horaGenerado.value) + " · los datos se calculan al momento de la consulta.", 1)
            ], 64))
          : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[11] || (_cache[11] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})